import { Box, Container, alpha, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { DjHeader } from './DjHeader';

type Props = {
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

export function DjPageShell({ children, maxWidth = 'lg' }: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        color: 'common.white',
        backgroundImage: `
          linear-gradient(155deg, ${alpha(theme.palette.primary.dark, 0.38)} 0%, transparent 52%),
          radial-gradient(circle at 92% 6%, ${alpha(theme.palette.secondary.dark, 0.3)} 0%, transparent 30%),
          radial-gradient(circle at 8% 74%, ${alpha(theme.palette.warning.dark, 0.14)} 0%, transparent 28%),
          repeating-linear-gradient(135deg, ${alpha(theme.palette.common.white, 0.025)} 0 1px, transparent 1px 18px)
        `,
        backgroundColor: '#0B1120',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: { xs: 78, md: 96 },
          right: { xs: -180, md: -120 },
          left: { xs: '42%', md: '50%' },
          height: { xs: 270, md: 360 },
          pointerEvents: 'none',
          background: `linear-gradient(112deg, transparent 0 18%, ${alpha(theme.palette.secondary.light, 0.13)} 18% 28%, transparent 28% 42%, ${alpha(theme.palette.warning.light, 0.1)} 42% 51%, transparent 51%)`,
          transform: 'skewY(-8deg)',
        },
      }}
    >
      <DjHeader />
      <Container maxWidth={maxWidth} sx={{ position: 'relative', zIndex: 1, py: { xs: 2.25, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        {children}
      </Container>
    </Box>
  );
}
